export const enhanceDistance = (distance: string) => {
  let enhancedDistance = distance;

  if (distance.includes('minutes')) {
    enhancedDistance = distance.replace('minutes', 'mins');
  } else if (distance.includes('minute')) {
    enhancedDistance = distance.replace('minute', 'min');
  } else if (distance.includes('seconds') || distance.includes('second')) {
    enhancedDistance = '1 min';
  }

  return enhancedDistance;
};
